import { render, staticRenderFns } from "./DetalleOrdinario.vue?vue&type=template&id=83d14e46"
import script from "./DetalleOrdinario.vue?vue&type=script&lang=js"
export * from "./DetalleOrdinario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports